import React from 'react'
import PropTypes from 'prop-types'
import LeftArrow from 'react-icons/lib/md/arrow-back'
import RightArrow from 'react-icons/lib/md/arrow-forward'
import Close from 'react-icons/lib/md/clear'
import Check from 'react-icons/lib/md/check'
import cn from 'classnames'

import './styles.scss'

export const bc = 'tour-tooltip'

const TourTooltip = ({ t, continuous, index, step, tooltipProps, size, isLastStep, setStepIndex, setRun }) => {
  const createArrayOfNumbers = number => {
    let results = []
    for (let i = 0; i < number; i++) {
      results.push(i)
    }
    return results
  }
  const sizeSteps = createArrayOfNumbers(size)
  return (
    <div className={`${bc}__wrapper`} {...tooltipProps}>
      {step.title && <span className={`${bc}__title`}>{step.title}</span>}
      <div className={`${bc}__content`}>{t(step.content)}</div>
      <div className={`${bc}__footer`}>
        {index > 0 && (
          <div className={`${bc}__button`} onClick={() => setStepIndex(index - 1)}>
            <LeftArrow />
          </div>
        )}
        {sizeSteps.map((el, i) => (
          <div
            className={cn(`${bc}__button`, `${bc}__button-circle`, { [`${bc}__button-circle-active`]: i === index })}
            onClick={() => setStepIndex(i)}
            key={i}
          />
        ))}
        {continuous && (
          <div className={`${bc}__button`}>
            {isLastStep ? (
              <Check onClick={() => setRun(false)} viewBox="5 5 35 35" style={{ color: 'green' }} />
            ) : (
              <RightArrow onClick={() => setStepIndex(index + 1)} />
            )}
          </div>
        )}
      </div>
      <div onClick={() => setRun(false)} className={cn(`${bc}__button`, `${bc}__button-close`)}>
        <Close />
      </div>
    </div>
  )
}

TourTooltip.propTypes = {
  continuous: PropTypes.bool,
  index: PropTypes.number.isRequired,
  step: PropTypes.object.isRequired,
  tooltipProps: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  setStepIndex: PropTypes.func.isRequired,
  setRun: PropTypes.func.isRequired,
}

export default TourTooltip
